﻿let _ = require('lodash');
let SizerBreakpoint = require('../SizerBreakpoint');

module.exports = GeneralSearch;

var hsiPage = false
if($("#hsi-body").length !== 0){
    hsiPage= true;
}



function GeneralSearch(options) {
    _.assign(this, options);

    new SizerBreakpoint({
        element: this.element
    });

    $(this.button).click(() => {
        this.open();
        this.container.parent().addClass("search-open");
    });
    $(this.closeButton).click(() => {
        this.close()
        this.container.parent().removeClass("search-open");
    });
    $(this.closeButton).click(() => this.close());

    $(window).click(e => {
        if ($(e.target).closest(this.container).length) { return; }
        this.close();
    });

    $(window).on('resize', () => {
        if (this.isOpen) {
            this.resize();
        }
    })
}

GeneralSearch.prototype = {
    open() {
        this.setFocus();
        this.resize();
        this.isOpen = true;
    },

    resize() {
        if(hsiPage && $(window).width() < 769){
            var screenWidth = window.outerWidth;
            screenWidth = screenWidth - 200;
            var screenResult = "width:"+ screenWidth + "px"
            $(".jnf-widget.general-search-box .query-input").attr("style",screenResult);
        }

        let width = 0;
        this.container.children().each(function () {
            width += $(this).is(":visible") ? $(this).outerWidth(true) : 0;
        });

        this.container.width(width);    
    },

    setFocus() {
        let query = this.input.val() || '';
        let queryLength = query.length;

        this.input.focus();
        this.input[0].setSelectionRange(queryLength, queryLength);
    },

    close() {
        this.container.width('');
        this.isOpen = false;
    }
}